import React, { FC } from 'react';
import { ServiceData, SlotService } from '../../../../utils/state/types';
import { AddToCartErrorType, FormError } from '../../../../types/errors';
import { Modal } from '../../Modal';
import { Trans, useTranslation } from '@wix/yoshi-flow-editor';
import { mapToArray } from '../../../../utils';
import { CartErrorModalDatahooks } from './datahooks';
import { getErrorByType } from '../../../../utils/errors/errors';
import { useFormActions } from '../../Hooks/useFormActions';
import { CartFlow, FlowType } from '../../../../types/types';

export interface CartErrorModalProps {
  serviceData: ServiceData;
  errors: FormError[];
}

const CartErrorModal: FC<CartErrorModalProps> = ({ serviceData, errors }) => {
  const { t } = useTranslation();

  const { onClickViewCart, submitForm, onClickCloseCartErrorModal, onSubmit } =
    useFormActions();
  const addToCartError = getErrorByType({
    errorType: AddToCartErrorType,
    errors,
  });

  if (!addToCartError) {
    return null;
  }
  const servicesArray = mapToArray<SlotService>(serviceData.slotServices);

  const serviceCount = servicesArray.length;

  const serviceName = servicesArray[0].service.name;

  let title: string, contentKey: string;

  if (serviceCount > 1) {
    title = t(
      'app.bookings-form.multi-location.cart-modal.service-could-not-be-added.multi-service-title',
      { count: serviceCount },
    );

    contentKey =
      'app.bookings-form.multi-location.cart-modal.service-could-not-be-added.multi-service-content';
  } else {
    title = t(
      'app.bookings-form.multi-location.cart-modal.service-could-not-be-added.title',
    );

    contentKey =
      'app.bookings-form.multi-location.cart-modal.service-could-not-be-added.content';
  }

  return (
    <Modal
      modalTitle={title}
      modalSubtitle={
        <Trans
          i18nKey={contentKey}
          components={{ b: <strong /> }}
          values={{ serviceName }}
        />
      }
      primaryButton={{
        label: t(
          'app.bookings-form.multi-location.cart-modal.service-could-not-be-added.primary-button',
        ),
        onClick: async () => {
          onClickCloseCartErrorModal();
          const submissionResponse = submitForm(true);

          if (submissionResponse) {
            onSubmit({
              submissionResponse,
              flowType: FlowType.SINGLE_SESSION,
              cartFlow: CartFlow.CHECKOUT,
            });
          }
        },
      }}
      secondaryButton={{
        label: t(
          'app.bookings-form.multi-location.cart-modal.service-could-not-be-added.secondary-button',
        ),
        onClick: () => onClickViewCart(),
      }}
      dataHook={CartErrorModalDatahooks.Modal}
      onClose={onClickCloseCartErrorModal}
    />
  );
};

export default CartErrorModal;
